import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class SubsidiaryMemorandumService {
  constructor(private coreService: CoreService) {}

  getUnderstandingList(params: any, pageIndex: number = 0, pageSize: number = 0): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.memorandum.getUnderstandingList,
      
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)  
      .append('Id', params && params.Id ? params.Id : '')
      .append('Title', params && params.Title ? params.Title : '')
      .append('ContractNumber', params && params.ContractNumber ? params.ContractNumber : '')
      .append('ContractNumberAttachment', params && params.ContractNumberAttachment ? params.ContractNumberAttachment : '')
      .append('CustomerId', params && params.CustomerId ? params.CustomerId : '')
      .append('ContractDateStart', params && params.ContractDateStart ? params.ContractDateStart : '')
      .append('ContractDateEnd', params && params.ContractDateEnd ? params.ContractDateEnd : '')
      .append('TermInfoId', params && params.TermInfoId ? params.TermInfoId : '')
  );
  }
  // add memorandum 
  understandingAdd(command: any): Observable<any> {
    return this.coreService.post(
      ServiceRoute.subsidiary.memorandum.understandingAdd,
      command,
      new CommonHttpOption().headers
    );
  }

  // edit memorandum 
  understandingEdit(command: any): Observable<any> {
  return this.coreService.put(
    ServiceRoute.subsidiary.memorandum.understandingEdit,
    command,
    new CommonHttpOption().headers
  );
}
// delete memorandum
understandingDelete(data : any): Observable<any> {
  return this.coreService.delete(
    ServiceRoute.subsidiary.memorandum.understandingDelete,
    new CommonHttpOption().headers,
    data
  );
}
 
}
